import React from 'react';

import { oneLineAddress } from 'Utilities/formatHelper';
import i18n from 'Utilities/i18n';

import styles from './PracticeDetails.module.scss';

type Props = Practice;

const PracticeDetails: React.FC<React.PropsWithChildren<Props>> = ({
  address1,
  address2,
  city,
  id,
  name,
  state,
  phoneNumber,
  practiceId,
  zip,
}) => {
  const address = oneLineAddress({ address1, address2, city, state, zip });

  return (
    <div id={`practiceDetails-${id}`} className="d-flex flex-column">
      {/* Name */}
      <span id="practiceName" className={styles.name}>
        {name}
      </span>

      {/* ID */}
      {practiceId && (
        <div className={`d-flex flex-column mt-3 ${styles.field}`}>
          <span id="practiceId-label" className="text-md">
            {i18n.t('LV.practiceId')}
          </span>
          <span id="practiceId-value">{practiceId}</span>
        </div>
      )}

      {/* Address */}
      <div className={`d-flex flex-column mt-3 ${styles.field}`}>
        <span id="address-label" className="text-md">
          {i18n.t('LV.practiceAddress')}
        </span>
        <span id="address-value">{address}</span>
      </div>

      {/* Phone number */}
      <div className={`d-flex flex-column mt-3 ${styles.field}`}>
        <span id="phoneNumber-label" className="text-md">
          {i18n.t('LV.practicePhone')}
        </span>
        <span id="phoneNumber-value">{phoneNumber}</span>
      </div>
    </div>
  );
};

export default PracticeDetails;
